import Immutable from 'immutable';

export function addToSet(path, element) {
    return (acc, id) => acc.updateIn(path.concat([id]), Immutable.Set(), old => old.add(element));
}

export function removeFromSet(path, element) {
    return (acc, id) =>
        acc.updateIn(path, Immutable.Map(), container => {
            let value = container.get(id, Immutable.Set());
            value = value.delete(element);
            if (value.isEmpty()) {
                return container.delete(id);
            }
            return container.set(id, value);
        });
}
